<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="800px"
    class="alipay-dialog"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div class="employee-selector">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" size="small" class="search-form">
          <el-form-item>
            <el-input
              v-model="keywords"
              placeholder="姓名|手机号"
              clearable
              prefix-icon="el-icon-search"
              class="search-input"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-cascader
              v-model="department_id"
              :props="cascaderProps"
              :options="departmentData"
              :show-all-levels="false"
              placeholder="请选择部门"
              clearable
              class="department-cascader"
              @change="changeDepartmentValue"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="chooseItem">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="mList"
          height="350"
          stripe
          border
          size="small"
          v-loading="loading"
          element-loading-text="加载中..."
          :row-class-name="tableRowClassName"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="50" align="center">
            <template slot-scope="scope">
              <el-radio
                v-model="curShop"
                :label="scope.row"
                @input.native="clickChange(scope.row, scope.$index)"
              >{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            label="姓名"
            width="120"
            prop="name_cn"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="employee-name">{{ scope.row.name_cn }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="部门"
            min-width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="dept-text">{{ scope.row.department ? scope.row.department.name : '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="手机号"
            width="140"
            prop="mobile"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="mobile-text">{{ scope.row.mobile || '--' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <el-button size="small" @click="close">取消</el-button>
        <el-button size="small" type="primary" @click="ok">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'eEmployeeList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
    closeForm: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      departmentData: [],
      department_id: '',
      index: '',
      curShop: '',
      id: '',
      name: '',
      keywords: '',
      fileList: [],
      mList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      item: {},
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: true,
      },
    }
  },
  mounted() {
    this.getDepartmentList()
    this.getList()
  },
  methods: {
    getDepartmentList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      this.$axios.departmentTree(param).then(res => {
        if (res.code === 200) {
          this.departmentData = res.data
        }
      }).catch(err => console.log(err))
    },
    changeDepartmentValue(e) {
      if (e && e.length) {
        this.department_id = e[e.length - 1]
      } else {
        this.department_id = ''
      }
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.getList()
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.getList()
    },
    onClose() {
      this.$emit('update:visible', false)
    },
    close() {
      this.$emit('update:visible', false)
    },
    ok() {
      // 触发回调，将选中数据传回父组件
      if (this.formData.id) {
        this.$emit('eventChoose', this.id, this.name, this.item)
      }
      this.$emit('update:visible', false)
      this.closeForm()
    },
    getList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      if (this.keywords) param.keywords = this.keywords
      if (this.department_id) param.department_id = this.department_id

      this.$axios.shopEmployeeListP(param).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.mList = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    clickChange(row, index) {
      this.index = index
      this.id = row.id
      this.name = row.name_cn
      // this.formData.name = row.name_cn
      // this.formData.id = row.id
      // this.formData.department_name = row.department ? row.department.name : ''
      // this.formData.department_id = row.department ? row.department.id : ''
      this.item = this.mList[index]
    },
    handleRowClick(row, index) {
      this.clickChange(row, index)
    },
    chooseItem() {
      this.pageNum = 1
      this.getList()
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    },
  },
  watch: {
    visible(val) {
      if (val) {
        // 每次打开时重置选中状态
        this.curShop = null
        this.id = ''
        this.name = ''
        this.item = {}
        if (this.formData.id) {
          // 如果父组件传入了默认值，可尝试匹配（可选）
        }
        this.getList()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

::v-deep .alipay-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 35px -8px rgba(0, 0, 0, 0.2);
    
    .el-dialog__header {
      border-bottom: 1px solid $border-color;
      padding: 20px 24px;
      background: white;
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: $text-primary;
      }
      .el-dialog__headerbtn {
        top: 20px;
        right: 24px;
        .el-dialog__close {
          color: $text-secondary;
          font-size: 18px;
          &:hover {
            color: $primary-color;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 24px;
    }
  }
}

.employee-selector {
  .search-bar {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid $border-color;
    
    .search-form {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      align-items: center;
      
      ::v-deep .el-form-item {
        margin-bottom: 0;
        .el-form-item__content {
          line-height: 32px;
        }
      }
      
      .search-input {
        width: 200px;
        ::v-deep .el-input__inner {
          border-radius: 20px;
          border-color: $border-color;
          &:focus {
            border-color: $primary-color;
            box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
          }
        }
      }
      
      .department-cascader {
        width: 200px;
        ::v-deep .el-input__inner {
          border-radius: 20px;
          border-color: $border-color;
          &:focus {
            border-color: $primary-color;
            box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
          }
        }
      }
      
      .el-button--primary {
        border-radius: 20px;
        background: $primary-color;
        border: none;
        padding: 8px 20px;
        font-weight: 500;
        &:hover {
          background: lighten($primary-color, 8%);
        }
      }
    }
  }
  
  .table-wrapper {
    margin-bottom: 20px;
    
    ::v-deep .el-table {
      border-radius: 12px;
      overflow: hidden;
      font-size: 13px;
      
      th {
        background: $bg-gray !important;
        color: $text-secondary;
        font-weight: 500;
        padding: 12px 0;
        border-bottom: 1px solid $border-color;
      }
      
      td {
        padding: 12px 0;
        border-bottom: 1px solid $border-color;
      }
      
      .even-row {
        background: #ffffff;
      }
      .odd-row {
        background: #fbfbfc;
      }
      .hover-row > td {
        background: rgba($primary-color, 0.02) !important;
      }
      
      .el-radio__input.is-checked .el-radio__inner {
        background: $primary-color;
        border-color: $primary-color;
      }
      
      .employee-name {
        font-weight: 500;
        color: $text-primary;
      }
      .dept-text, .mobile-text {
        color: $text-regular;
      }
    }
  }
  
  .pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid $border-color;
    
    ::v-deep .el-pagination {
      .el-pagination__total, .el-pagination__jump {
        color: $text-secondary;
        font-size: 13px;
      }
      .btn-prev, .btn-next, .el-pager li {
        border-radius: 8px;
        margin: 0 4px;
        font-weight: 500;
        &:hover {
          color: $primary-color;
        }
      }
      .el-pager li.active {
        background: $primary-color;
        color: white;
        &:hover {
          background: lighten($primary-color, 8%);
        }
      }
    }
  }
  
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid $border-color;
    
    .el-button {
      border-radius: 20px;
      padding: 7px 20px;
      font-weight: 500;
      
      &:first-child {
        border-color: $border-color;
        color: $text-regular;
        &:hover {
          border-color: $primary-color;
          color: $primary-color;
        }
      }
      
      &.el-button--primary {
        background: $primary-color;
        border: none;
        &:hover {
          background: lighten($primary-color, 8%);
        }
      }
    }
  }
}
</style>